import { useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { TeamMembersPage } from '@roselabs-io/saas-shell'
import { useAuth } from '../lib/auth'
import { teamsApi } from '../api/teams'

export default function MembersPage() {
  const { teamId } = useParams<{ teamId: string }>()
  const { user } = useAuth()

  if (!teamId || !user) {
    return null
  }

  return (
    <TeamMembersPage
      teamId={teamId}
      currentUserId={user.id}
      getMembers={teamsApi.getMembers}
      getInvites={teamsApi.getInvites}
      createInvite={teamsApi.createInvite}
      updateMemberRole={teamsApi.updateMemberRole}
      removeMember={async (tId, userId) => {
        await teamsApi.removeMember(tId, userId)
      }}
      cancelInvite={async (tId, inviteId) => {
        await teamsApi.cancelInvite(tId, inviteId)
      }}
      resendInvite={async (tId, inviteId) => {
        await teamsApi.resendInvite(tId, inviteId)
      }}
      onToast={(message, type) => {
        if (type === 'success') toast.success(message)
        else toast.error(message)
      }}
    />
  )
}
